module.exports = __webpack_public_path__ + "static/media/twitter (2).8f35a404.png";